import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable, signal, WritableSignal } from '@angular/core';

export const BootstrapBreakpoints = {
  // --- "Up" Breakpoints (Standard Bootstrap logic) ---
  // Matches the specific size and everything larger
  xs: '(max-width: 575.98px)',
  sm: '(min-width: 576px) and (max-width: 767.98px)',
  md: '(min-width: 768px) and (max-width: 991.98px)',
  lg: '(min-width: 992px) and (max-width: 1199.98px)',
  xl: '(min-width: 1200px) and (max-width: 1399.98px)',
  xxl: '(min-width: 1400px)',
};

export const findActiveBreakpoint = (obj: Record<string, boolean>): string =>
  Object.keys(obj).find((key) => obj[key] === true);
export const findBreakpointName = (breakpointsObj, activeBreakpoint) =>
  Object.keys(breakpointsObj).find(
    (key) => breakpointsObj[key] === activeBreakpoint
  );
export const getBreakpointName = (breakpointsResult, breakpointsObject) => {
  const active = findActiveBreakpoint(breakpointsResult);
  const result = findBreakpointName(breakpointsObject, active);
  return result;
};

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  // A state meant to be shared
  public currentBreakpoint: WritableSignal<string> = signal('');
  public isMobile = signal(false);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([
        BootstrapBreakpoints.xs,
        BootstrapBreakpoints.sm,
        BootstrapBreakpoints.md,
        BootstrapBreakpoints.lg,
        BootstrapBreakpoints.xl,
        BootstrapBreakpoints.xxl,
      ]) // You can use predefined or custom queries
      .subscribe((result) => {
        console.log('break-point.service.  ', result, BootstrapBreakpoints);
        if (result.matches) {
          const bpName = getBreakpointName(
            result.breakpoints,
            BootstrapBreakpoints
          );
          console.log('     ', bpName);
          this.currentBreakpoint.set(bpName || '');
          this.isMobile.set(['xs', 'sm', 'md'].includes(bpName || ''));
        }
      });
  }
}
